var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-icon home-icon",on:{"click":_vm.clickIcon}},[_c('router-link',{attrs:{"to":"/"}},[_c('font-awesome-icon',{attrs:{"icon":"home"}}),_c('p',[_vm._v("Home")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }